import script from "./StoreList.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreList.vue?vue&type=script&setup=true&lang=js"

import "./StoreList.vue?vue&type=style&index=0&id=8b1a238c&lang=less&scoped=true"

import exportComponent from "/usr/share/nginx/html/vue_saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b1a238c"]])

export default __exports__